import React from 'react';
import { FormattedMessage } from 'react-intl';
import { openAdminPanel } from '@/utils/ShellUtils';
import cssStyles from './Dropdown.css';

class ManageTeam extends React.PureComponent {
  render() {
    return (
      <div
        role='menuitem'
        tabIndex='-1'
        onKeyDown={() => {}}
        className={cssStyles.dropdown_list_item}
        onClick={openAdminPanel}
      >
        <div className={cssStyles.menu_item_info}>
          <FormattedMessage id='manage_team' />
        </div>
      </div>
    );
  }
}

export default ManageTeam;



// WEBPACK FOOTER //
// ./src/components/appMenu/ManageTeam.js